const commaDecimalToDecimal = (value: any) => {
  return parseFloat(`${value}`.replace(",", "."));
};
export default commaDecimalToDecimal;
